// extracted by mini-css-extract-plugin
export var main = "_3-1";
export var shell = "_3-0";